import { OnboardingComplete } from "../components/OnboardingComplete/OnboardingComplete";

export function OnboardingOnboardingCompletedPage() {
  return (
    <>
      <OnboardingComplete />
    </>
  );
}

export default OnboardingOnboardingCompletedPage;
